import React from "react";
import { Col, Form, Input, Row, Select } from "antd";
import { useStateChanges } from "../../base/hooks/useStateChanges";
import { useCountriesAndData } from "../../base/hooks/useCountriesAndData";

const LocationSection = React.memo(({ form }) => {
   const { countries, selectedCountry, states, handleCountryChange } = useCountriesAndData(form);
   const { cities, handleStateChange } = useStateChanges(selectedCountry, form);

   const onCountryChange = (selectedOption) => {
      handleCountryChange(selectedOption, {
         governorateOrProvince: null,
         cityOrCampOrVillage: null
      });
   };

   const onStateChange = (selectedOption) => {
      handleStateChange(selectedOption, { cityOrCampOrVillage: null });
   };

   return (
      <>
         <div className="mt-8 mb-5">
            <h4>Location</h4>
         </div>
         <Row gutter={24}>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="userCountryId"
                  label={<span className="label-text required">Country</span>}
                  rules={[{ required: true, message: "Please enter country" }]}
               >
                  <Select
                     placeholder="Select an option"
                     showSearch
                     allowClear
                     filterOption={(input, option) => {
                        return (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase());
                     }}
                     onChange={(selectedCountry) => {
                        const selectedCountryName = countries.find(
                           (country) => country.id === selectedCountry
                        );
                        if (selectedCountryName) {
                           onCountryChange(selectedCountryName);
                        }
                     }}
                     options={countries.map((item) => ({
                        value: item.id,
                        label: item.name
                     }))}
                  />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="governorateOrProvince"
                  label={<span className="label-text required">State</span>}
                  rules={[{ required: true, message: "Please select state" }]}
               >
                  <Select
                     placeholder="Select an option"
                     showSearch
                     allowClear
                     filterOption={(input, option) => {
                        return (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase());
                     }}
                     onChange={(selectedState) => {
                        const selectedStateName = states.find(
                           (state) => state.name === selectedState
                        );
                        if (selectedState) {
                           onStateChange(selectedStateName);
                        }
                     }}
                     options={states.map((item) => ({
                        value: item.name,
                        label: item.name
                     }))}
                  />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item name="district" label={<span className="label-text">District</span>}>
                  <Input placeholder="Type down the district" />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="subdistrict"
                  label={<span className="label-text">Subdistrict</span>}
               >
                  <Input placeholder="Type down the subdistrict" />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="cityOrCampOrVillage"
                  label={
                     <span className={`label-text ${cities.length > 0 ? "required" : ""} `}>
                        City
                     </span>
                  }
                  rules={[{ required: cities.length > 0, message: "Please select a city" }]}
               >
                  <Select
                     placeholder="Select an option"
                     showSearch
                     allowClear
                     filterOption={(input, option) => {
                        return (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase());
                     }}
                     options={cities.map((item) => ({
                        value: item.name,
                        label: item.name
                     }))}
                  />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="neighborhoodOrSector"
                  label={<span className="label-text">Village/Neighborhood</span>}
               >
                  <Input placeholder="Type down the village or neighborhood" />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="houseOrTentDetails"
                  label={<span className="label-text required">Address line</span>}
                  rules={[{ required: true, message: "Please enter address" }]}
                  required
               >
                  <Input placeholder="Address line" />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item name="zipCode" label={<span className="label-text">ZIP code</span>}>
                  <Input type="number" placeholder="ZIP code" />
               </Form.Item>
            </Col>
         </Row>
      </>
   );
});

export default LocationSection;
